import PathwayReportsContainer from './pathway_reports_container';

const PathwayReports = PathwayReportsContainer;
export default PathwayReports;
